import { AddressDataType } from "../Interfaces/PayloadsAndResponses/Address";

export const modifyAddressInUrl = (fetchedAddress: AddressDataType, fromChowmill?: boolean) => {

  const url = new URL(window.location.href);
  const params = url.searchParams;

  const addressValue = fetchedAddress.formatted_address || fetchedAddress.address_line;
  url.pathname = '/'
  if (fromChowmill) {
    params.delete('placeId')
  }
  params.set('address', addressValue);
  url.search = params?.toString();

  window.history.replaceState({}, '', url?.toString());

}